import { useContext } from "react";
import SwitchTitleDescription from "./common/SwitchTitleDescription";
import GraphConfigFormContext from "@/store/contexts/GraphConfigFormContext";
import { useTranslation } from "react-i18next";

const AdvancedOptions = () => {
  const { config, setConfig } = useContext(GraphConfigFormContext);
  const { t } = useTranslation();

  if (!config) return null;

  return (
    <div className="flex flex-col w-full px-4 pt-4 pb-[100px] gap-4">
      <SwitchTitleDescription
        title={t("editor.graphConfig.advancedOptions.fullScreen")}
        description={t("editor.graphConfig.advancedOptions.fullScreenDescription")}
        value={config.view_options.fullScreenEnabled}
        onChange={(checked: boolean) =>
          setConfig({
            ...config,
            view_options: {
              ...config.view_options,
              fullScreenEnabled: checked,
            },
          })
        }
      />
      <SwitchTitleDescription
        title={t("editor.graphConfig.advancedOptions.autoRefresh")}
        description={t("editor.graphConfig.advancedOptions.autoRefreshDescription")}
        value={config.view_options.autoRefresh}
        onChange={(checked: boolean) =>
          setConfig({
            ...config,
            view_options: {
              ...config.view_options,
              autoRefresh: checked,
            },
          })
        }
      />
    </div>
  );
};

export default AdvancedOptions;
